<template>
  <el-card class="box-card" shadow="never" style="display: block;">
    <div slot="header" class="clearfix">
      <span>运营分详情展示</span>
    </div>
    <div class="background_core">
      <el-row>
        <el-col :span="10">
          <div class="physical">
            <main class="man_zhanshi">
              <el-progress type="circle" :percentage="per"  :show-text="false"></el-progress>
              <div class="abs_num" >{{last.shop_member_score}}
              </div>
              <div class="name">店铺综合得分</div>
              <div class=" float-show1" v-show="Object.keys(second).length ==  0 || last.shop_member_score == second.shop_member_score"> 较上次 - -</div>

              <div class=" float-show" v-show="second && last.shop_member_score > second.shop_member_score">较上次
                <i class="el-icon-caret-top"></i>{{Math.abs(last.shop_member_score - second.shop_member_score).toFixed(2)}}分</div>

              <div class=" float-show" v-show="second && last.shop_member_score < second.shop_member_score"> 较上次
                <i class="el-icon-caret-bottom"></i>{{Math.abs(last.shop_member_score - second.shop_member_score).toFixed(2)}}分</div>
            </main>
          </div>
        </el-col>
        <el-col :span="14">
          <el-row>
            <el-col :span="12">
              <el-row>
                <el-col :span="8">
                  <div class="diyi">运营分</div>
                  <div class="dier">{{last.opert_capab}}</div>
                </el-col>
                <el-col :span="16">
                  <div class="row-float-show" v-show="Object.keys(second).length ==  0 || last.opert_capab == second.opert_capab"> 较上次 <div>&nbsp;&nbsp;&nbsp;- -</div></div>
                  <div class="row-float-show" v-show="second && last.opert_capab > second.opert_capab">较上次 <div>
                    <i class="el-icon-caret-top"></i>{{Math.abs(last.opert_capab - second.opert_capab).toFixed(2)}}分</div> </div>
                  <div class="row-float-show" v-show="second && last.opert_capab < second.opert_capab"> 较上次 <div>
                    <i class="el-icon-caret-bottom"></i>{{Math.abs(last.opert_capab - second.opert_capab).toFixed(2)}}分</div></div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="8">
                  <div class="diyi">商家分</div>
                  <div class="dier">{{last.shop_capab	}}</div>
                </el-col>
                <el-col :span="16">
                  <div class="row-float-show" v-show="Object.keys(second).length ==  0 || last.shop_capab == second.shop_capab"> 较上次 <div>&nbsp;&nbsp;&nbsp;- -</div></div>
                  <div class="row-float-show" v-show="second && last.shop_capab > second.shop_capab">较上次
                    <div><i class="el-icon-caret-top"></i>{{Math.abs(last.shop_capab - second.shop_capab).toFixed(2)}}分</div></div>
                  <div class="row-float-show" v-show="second && last.shop_capab < second.shop_capab"> 较上次
                    <div><i class="el-icon-caret-bottom"></i>{{Math.abs(last.shop_capab - second.shop_capab).toFixed(2)}}分</div></div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-row>
                <el-col :span="8">
                  <div class="diyi">商品分</div>
                  <div class="dier">{{last.sku_capab}}</div>
                </el-col>
                <el-col :span="16">
                  <div class="row-float-show" v-show="Object.keys(second).length ==  0 || last.sku_capab == second.sku_capab"> 较上次 <div>&nbsp;&nbsp;&nbsp;- -</div></div>
                  <div class="row-float-show" v-show="second && last.sku_capab > second.sku_capab">较上次 <div>
                    <i class="el-icon-caret-top"></i>{{Math.abs(last.sku_capab - second.sku_capab).toFixed(2)}}分</div></div>
                  <div class="row-float-show" v-show="second && last.sku_capab < second.sku_capab"> 较上次 <div>
                    <i class="el-icon-caret-bottom"></i>{{Math.abs(last.sku_capab - second.sku_capab).toFixed(2)}}分</div></div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="8">
                  <div class="diyi">服务分</div>
                  <div class="dier">{{last.service_capab}}</div>
                </el-col>
                <el-col :span="16">
                  <div class="row-float-show" v-show="Object.keys(second).length ==  0 || last.service_capab == second.service_capab"> 较上次 <div>&nbsp;&nbsp;&nbsp;- -</div></div>
                  <div class="row-float-show" v-show="second && last.service_capab > second.service_capab">较上次 <div>
                    <i class="el-icon-caret-top"></i>{{Math.abs(last.service_capab - second.service_capab).toFixed(2)}}分</div> </div>
                  <div class="row-float-show" v-show="second && last.service_capab < second.service_capab"> 较上次 <div>
                    <i class="el-icon-caret-bottom"></i>{{Math.abs(last.service_capab - second.service_capab).toFixed(2)}}分</div> </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <template>
      <el-table
              :data="tableData"
              height="200px"
              style="width: 100%"
              @row-click="getDetails"
      >
        <el-table-column
                prop="user_key"
                label="会员id"
                width="100">
        </el-table-column>
        <el-table-column
                prop="stat_date"
                label="计算日期"
                >
        </el-table-column>
        <el-table-column
                prop="shop_member_score"
                label="店铺综合得分"
                width="150">
        </el-table-column>
        <el-table-column
                prop="shop_star"
                label="店铺星级"
                width="150">
        </el-table-column>
        <el-table-column
                prop="service_capab"
                label="服务能力分"
                width="150">
        </el-table-column>
        <el-table-column
                prop="sku_capab"
                label="商品能力分"
                width="150"
        >
        </el-table-column>
        <el-table-column
                prop="shop_capab"
                label="商家能力分"
                width="150"
        >
        </el-table-column>
        <el-table-column
                prop="opert_capab"
                label="运营能力分"
                width="150">
        </el-table-column>
        <el-table-column
                prop="irregular_behavior"
                label="违规行为个数"
                width="150">
        </el-table-column>
        <el-table-column
                fixed="right"
                prop="repeat_url"
                label="操作"
                width="100">
          <el-button type="text"  style="width: 80px" @click="otherInfoDialogVisible = true" >其他信息</el-button>
        </el-table-column>
      </el-table>
    </template>
    <template>
      <el-dialog
              :visible.sync="otherInfoDialogVisible"
              center
              width="100%"
              :modal="false"
              :destroy-on-close="true">
        <table style="width: 100%" class="scoreCustomTable">
          <tr>
            <el-row>
              <el-col :span="4"><th>表单询盘24小时响应率</th></el-col>
              <el-col :span="4"><th>表单询盘24小时响应率得分	</th></el-col>
              <el-col :span="4"><th>表单询盘24小时响应率行业表现	</th></el-col>
              <el-col :span="4"><th>IM消息3分钟响应率	</th></el-col>
              <el-col :span="4"><th>IM消息3分钟响应率得分	</th></el-col>
              <el-col :span="4"><th>IM消息3分钟响应率行业表现	</th></el-col>
            </el-row>
          </tr>
          <tr>
            <el-row>
              <el-col :span="4"><td>{{rowDetails.inq_resp_intime_rate * 100	}} <span v-if="rowDetails.inq_resp_intime_rate != 0">%</span> </td></el-col>
              <el-col :span="4"><td>{{rowDetails.inq_resp_intime_score}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.inq_24h_resp_cate_cons	}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.im_resp_intime_rate * 100 }} <span v-if="rowDetails.im_resp_intime_rate != 0">%</span></td></el-col>
              <el-col :span="4"><td>{{rowDetails.im_resp_intime_score}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.im_3min_resp_cate_cons}}</td></el-col>
            </el-row>
          </tr>

          <tr>
            <el-row>
              <el-col :span="4"><th>品质退款率	</th></el-col>
              <el-col :span="4"><th>品质退款率得分		</th></el-col>
              <el-col :span="4"><th>品质退款率行业表现		</th></el-col>
              <el-col :span="4"><th>发货履约率		</th></el-col>
              <el-col :span="4"><th>发货履约率得分		</th></el-col>
              <el-col :span="4"><th>发货履约率行业表现		</th></el-col>
            </el-row>
          </tr>
          <tr>
            <el-row>
              <el-col :span="4"><td>{{rowDetails.refund_order_quality_rate	* 100	}} <span v-if="rowDetails.refund_order_quality_rate != 0">%</span> </td></el-col>
              <el-col :span="4"><td>{{rowDetails.refund_order_quality_score}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.refund_order_quality_cate_cons	}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.trade_intime_rate*100}} <span v-if="rowDetails.trade_intime_rate != 0">%</span></td></el-col>
              <el-col :span="4"><td>{{rowDetails.trade_intime_resp_score}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.trade_intime_resp_cate_cons}}</td></el-col>
            </el-row>
          </tr>

          <tr>
            <el-row>
              <el-col :span="4"><th>退款时长		</th></el-col>
              <el-col :span="4"><th>退款时长得分			</th></el-col>
              <el-col :span="4"><th>退款时长行业表现			</th></el-col>
              <el-col :span="4"><th>交易纠纷率			</th></el-col>
              <el-col :span="4"><th>交易纠纷率得分			</th></el-col>
              <el-col :span="4"><th>交易纠纷率行业表现			</th></el-col>
            </el-row>
          </tr>
          <tr>
            <el-row>
              <el-col :span="4"><td>{{rowDetails.refund_order_time_avg		}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.refund_order_time_score}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.refund_order_time_cate_cons	}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.trade_order_dispute_rate*100}} <span v-if="rowDetails.trade_order_dispute_rate != 0">%</span> </td></el-col>
              <el-col :span="4"><td>{{rowDetails.trade_order_dispute_score}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.trade_order_dispute_cate_cons}}</td></el-col>
            </el-row>
          </tr>

          <tr>
            <el-row>
              <el-col :span="4"><th>在线商品数</th></el-col>
              <el-col :span="4"><th>3星商品数</th></el-col>
              <el-col :span="4"><th>4星商品数</th></el-col>
              <el-col :span="4"><th>主推商品数</th></el-col>
              <el-col :span="4"><th>3星商品占比</th></el-col>
              <el-col :span="4"><th>3星商品占比得分</th></el-col>
            </el-row>
          </tr>
          <tr>
            <el-row>
              <el-col :span="4"><td>{{rowDetails.sku_cunt		}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.sku_quality_case_cunt||rowDetails.sku_quality_case_cunt_v2}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.sku_quality_advance_cunt||rowDetails.sku_quality_advance_cunt_v2	}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.sku_item_count}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.sku_quality_rate_base||rowDetails.sku_quality_rate_base_v2}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.sku_quality_score_base||rowDetails.sku_quality_score_base_v2}}</td></el-col>
            </el-row>
          </tr>

          <tr>
            <el-row>
              <el-col :span="4"><th>3星商品占比行业表现	</th></el-col>
              <el-col :span="4"><th>4星商品占比	</th></el-col>
              <el-col :span="4"><th>4星商品占比得分	</th></el-col>
              <el-col :span="4"><th>4星商品占比行业表现	</th></el-col>
              <el-col :span="4"><th>主推商品视频覆盖率	</th></el-col>
              <el-col :span="4"><th>主推商品视频覆盖率得分	</th></el-col>
            </el-row>
          </tr>
          <tr>
            <el-row>
              <el-col :span="4"><td>{{rowDetails.sku_quality_base_cate_cons||rowDetails.sku_quality_base_cate_cons_v2}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.sku_quality_rate_advance||rowDetails.sku_quality_rate_advance_v2}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.sku_quality_score_advance||rowDetails.sku_quality_advance_indicator_v2}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.sku_quality_advance_cate_cons||rowDetails.sku_quality_advance_cate_cons_v2}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.item_video_rate*100}} <span v-if="rowDetails.item_video_rate!=0">%</span> </td></el-col>
              <el-col :span="4"><td>{{rowDetails.item_video_score}}</td></el-col>
            </el-row>
          </tr>

          <tr>
            <el-row>
              <el-col :span="4"><th>主推商品视频覆盖率行业表现		</th></el-col>
              <el-col :span="4"><th>商家真实性认证		</th></el-col>
              <el-col :span="4"><th>商家真实性认证得分		</th></el-col>
              <el-col :span="4"><th>商家真实性认证行业表现		</th></el-col>
              <el-col :span="4"><th>商家深度认证得分		</th></el-col>
              <el-col :span="4"><th>商家深度认证行业表现		</th></el-col>
            </el-row>
          </tr>
          <tr>
            <el-row>
              <el-col :span="4"><td>{{rowDetails.item_video_cate_cons		}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.memberinfo_realcheck	}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.shop_real_score	}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.shop_real_cate_cons}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.super_shop_cert_score}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.super_shop_cert_cate_cons}}</td></el-col>
            </el-row>
          </tr>

          <tr>
            <el-row>
              <el-col :span="4"><th>是否通过实力工厂认证		</th></el-col>
              <el-col :span="4"><th>是否通过实力档口认证		</th></el-col>
              <el-col :span="4"><th>是否通过品牌店铺认证		</th></el-col>
              <el-col :span="4"><th>是否通过现货商家认证		</th></el-col>
              <el-col :span="4"><th>是否存在重复行为</th></el-col>
              <el-col :span="4"><th>重复铺货扣分</th></el-col>
            </el-row>
          </tr>
          <tr>
            <el-row>
              <el-col :span="4"><td>
                <span v-if="rowDetails.memberinfo_deeper_chk && rowDetails.memberinfo_deeper_chk.memberinfo_field_fac_check == 1">是</span>
                <span v-else>否</span>
              </td></el-col>
              <el-col :span="4"><td>
                <span v-if="rowDetails.memberinfo_deeper_chk && rowDetails.memberinfo_deeper_chk.memberinfo_field_stall_check == 1">是</span>
                <span v-else>否</span>
              </td></el-col>
              <el-col :span="4"><td>
                <span v-if="rowDetails.memberinfo_deeper_chk && rowDetails.memberinfo_deeper_chk.memberinfo_brand_shop_check == 1">是</span>
                <span v-else>否</span>
              </td></el-col>
              <el-col :span="4"><td>
                <span v-if="rowDetails.memberinfo_deeper_chk && rowDetails.memberinfo_deeper_chk.memberinfo_spot_check == 1">是</span>
                <span v-else>否</span>
              </td></el-col>

              <el-col :span="4"><td>
                <span v-if="rowDetails.sku_cluster_rate == 1||rowDetails.sku_cluster_rate_v2 == 1">存在</span>
                <span v-else>不存在</span>
              </td></el-col>
              <el-col :span="4"><td>
                <span>{{rowDetails.sku_cluster_score}}</span>
              </td></el-col>
            </el-row>
          </tr>

          <tr>
            <el-row>
              <el-col :span="4"><th>是否开通买家服务保障			</th></el-col>
              <el-col :span="4"><th>开通买家服务保障得分			</th></el-col>
              <el-col :span="4"><th>开通买家服务保障得分行业表现			</th></el-col>
              <el-col :span="4"><th>特色服务保障商品占比			</th></el-col>
              <el-col :span="4"><th>特色服务保障商品占比得分			</th></el-col>
              <el-col :span="4"><th>特色服务保障商品占比行业表现			</th></el-col>
            </el-row>
          </tr>
          <tr>
            <el-row>
              <el-col :span="4"><td>
                <span v-if="rowDetails.buyer_protect == 1">开通</span>
                <span v-else>未开通</span>
              </td></el-col>
              <el-col :span="4"><td>{{rowDetails.trade_protect_score	}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.buyer_protect_cate_cons	}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.sku_particular_pct * 100}} <span v-if="rowDetails.sku_particular_pct!=0">%</span> </td></el-col>
              <el-col :span="4"><td>{{rowDetails.sku_particular_score}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.sku_particular_cate_cons}}</td></el-col>
            </el-row>
          </tr>

          <tr>
            <el-row>
              <el-col :span="4"><th>店龄				</th></el-col>
              <el-col :span="4"><th>店龄得分				</th></el-col>
              <el-col :span="4"><th>提交优质答案数				</th></el-col>
              <el-col :span="4"><th>提交优质答案数得分				</th></el-col>
              <el-col :span="4"><th>提交优质答案数行业表现				</th></el-col>
              <el-col :span="4"><th>订单数				</th></el-col>
            </el-row>
          </tr>
          <tr>
            <el-row>
              <el-col :span="4"><td>小于{{rowDetails.memberinfo_prov_year}}年</td></el-col>
              <el-col :span="4"><td>{{rowDetails.shop_year_score	}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.wenda_month_add_cunt	}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.shop_wenda_score}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.shop_wenda_cate_cons}}</td></el-col>
              <el-col :span="4"><td>{{rowDetails.order_subtrade_cunt_month}}</td></el-col>
            </el-row>
          </tr>

          <tr>
            <el-row>
              <el-col :span="4"><th>销售额</th></el-col>
            </el-row>
          </tr>
          <tr>
            <el-row>
              <el-col :span="4"><td>{{rowDetails.order_payment_amount_month		}}</td></el-col>

            </el-row>
          </tr>
        </table>
      </el-dialog>
    </template>
  </el-card>

</template>
<style>
  .demo-table-expand label {
    width: 300px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item{
    margin-left: 300px;
    margin-bottom: auto;
    width: 100%;
  }
  .scoreCustomTable {
    align: center;
  }
</style>
<script>
    import {mapState, mapGetters,mapMutations} from "vuex";
    import ElRow from "element-ui/packages/row/src/row";
    export default {
        components: {ElRow},
        data() {
            return {
                activeName:"info",
                member_id:0,
                tableData: [],
                //一行数据的详细信息
                rowDetails:{},
                //其他信息弹出框状态
                otherInfoDialogVisible:false,
                //其他信息弹出框的子弹出框
                pictureUrlVisible:false,
                titleUrlVisible:false,
                paramUrlVisible:false,
                rtfUrlVisible:false,
                priceUrlVisible:false,
                experienceUrlVisible:false,
                repeatUrlVisible:false,
                repeatUrlTpVisible:false,


                last:{},
                second:{},
                per:0,
            }
        },
        computed: {
            ...mapGetters("navTabs", ["getParam"]),
            ...mapGetters("navTabs", ["tabTableHeight"]),
        },
        mounted() {
            this.getScoreDetail();
        },
        methods: {
            getScoreDetail(){
                let that = this;
                that.b_id =  localStorage.getItem('org_b_id');
                this.$ajax.post(this.$work_host+'/index.php/admin/login/updateScore',{b_id:that.b_id}).then(function (res) {
                    if(res.data.error === 0){
                        that.tableData = res.data.data;
                        that.last = res.data.data[0];
                        that.per = that.last.shop_member_score * 10;
                        if (res.data.data.length > 1){
                            that.second = res.data.data[1];
                        }
                    }
                })
            },
            getDetails(row){
                let that = this;
                that.rowDetails = JSON.parse(row.all_data);
            },
        }
    }
</script>
<style>
  .diyi{
    font-size: 18px;
    letter-spacing: 2px;
  }
  .dier{
    padding: 15px 0px 35px;
    font-size: 25px;
    font-weight: bold;
  }
  .man_zhanshi{
    position: relative;
  }
  .man_zhanshi .abs_num{
    position: absolute;
    top: 30px;
    font-weight: 600;
    font-size: 40px;
    color: #20A0FF;
    letter-spacing: 2px;
    left:193px;
    width: 100px;
  }
  .man_zhanshi .name{
    position: absolute;
    top: 80px;
    font-size: 16px;
    color: #20A0FF;
    left: 200px;
  }
  .man_zhanshi .float-show{
    position: absolute;
    top: 110px;
    font-size: 14px;
    left: 200px;
  }
  .man_zhanshi .float-show1{
    position: absolute;
    top: 110px;
    font-size: 14px;
    left: 210px;
  }
  .el-progress__text{
    display: none;
  }
  .man_zhanshi{
    padding: 0 0 20px 0;
    text-align: center;
  }
  .el-progress-circle{
    height: 165px !important;
    width: 165px !important;
  }
  .el-icon-caret-top{
    color: #20A0FF;
    font-size: 20px;
  }
  .el-icon-caret-bottom{
    color: red;
    font-size: 20px;
  }
  /*.float-show{*/
  /*  padding: 20px 0 0 0;*/
  /*}*/
  .row-float-show{
    padding: 0;
  }
  .row-float-show div{
    padding: 20px 0;
  }
  .physical{
    width: 485px;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center;
  }
  .el-card__header{
    background: #EBEEF5;
  }
  .background_core{
    background: #F5F7FA;
    padding: 20px 0 0 0;
    margin: 0 0 30px 0;
  }
  .el-button{
    border:0px;
  }
  .el-popover{
    word-break: break-word;
    line-height: 30px;
    overflow: auto;
    height: 400px;
    padding: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/page/store/Index.vue